import * as React from "react"
import { Nav, NavItem } from "react-bootstrap"
import { LinkContainer } from "react-router-bootstrap"
import routes, * as RoutesConfig from "../../routes"
import * as _ from "lodash"
import { IPatientDetail } from "@curefit/care-common";
import AppUtils from "../../utils/AppUtils";
import Popover from "../common/Popover";
import RelatedPatientList from "./RelatedPatientsList";
import { RouteUtils } from "../../routes";
import { ORION_IMG_URL } from "../../utils/AppConstants";
import { MaskNumber } from "@curefit/care-rangoon-integration"
import { IAppState } from "../../models/IAppState";
import { connect } from "react-redux";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import { EventNames } from "../../utils/EventTrackerConstants";

export interface LeftNavProps {
    patient: IPatientDetail;
    appointmentId?: string
}

interface LeftNavStateToProps {
    updatedPatientPhoneNumber: number;
    doctorSubServices?: [{
        subServiceType: { code: string };
    }]
    appTenant: string
}

interface PatientLeftNavState {
    isRelatedPopoverVisible: boolean
    selectedUrl: string;
    renderBoolean: boolean
}

class PatientLeftNav extends React.Component<LeftNavProps & LeftNavStateToProps, PatientLeftNavState> {

    constructor(props: LeftNavProps) {
        super(props as any);

    };

    state: PatientLeftNavState = {
        isRelatedPopoverVisible: false,
        selectedUrl: location.pathname,
        renderBoolean: false
    };

    getPatientNav = (currUrl: string): string => {
        return currUrl.replace(RoutesConfig.ROUTE_PARAMS_SEPARATOR + RoutesConfig.PATIENT_ID_PARAM, this.props.patient.id && this.props.patient.id.toString());
    };

    navigateToOtherPatientConsultationPage = (patientId: number, event: any): void => {
        this.toggleRelatedPatientPopover();
        RouteUtils.navigateToUrl(RouteUtils.getAllConsultationsUrl(patientId));
    };

    toggleRelatedPatientPopover = () => {
        this.setState(state => ({ isRelatedPopoverVisible: !state.isRelatedPopoverVisible }))
    };

    onMaskClick = () => {
        LocalStorageUtils.setClickEvents({ field: "Join Call", section: EventNames.Call_Widget, widget: "Audio Call" })
    }
    handleUrlChange = () => {
        setTimeout(() => {
            this.setState({ renderBoolean: !this.state.renderBoolean });
        }, 200);
    }
    render() {
        let _myInstance = this;
        let age = !_.isEmpty(this.props.patient) ? AppUtils.getFormattedAgeToDisplay(this.props.patient.formattedAge) : "";
        const { isRelatedPopoverVisible } = this.state;
        const { updatedPatientPhoneNumber, doctorSubServices, appTenant } = this.props;
        const isMobile: boolean = AppUtils.getIsMobile();
        const isTransformCoach = doctorSubServices && AppUtils.checkForTransformCoach(doctorSubServices);
        const routesList = isTransformCoach ? RoutesConfig.TRANSFORM_PATIENT_NAVS : RoutesConfig.PATIENT_NAVS;
        return (
            <React.Fragment>
                {!isMobile &&
                    <div className="navbar navbar-fixed-side patient-left-nav">
                        <div className="patient-info-wrapper">
                            <div className="patient-info">
                                <div className="patient-img">
                                    {this.props.patient.displayImage && <img src={this.props.patient.displayImage} />}
                                </div>
                                <div className="patient-details">
                                    <div className="patient-name">{this.props.patient.name}</div>
                                    <div className="patient-age-gender">
                                        {!_.isEmpty(age) ? `${age}, ` : ``}{this.props.patient.gender}
                                    </div>
                                    {!_.isEmpty(this.props.patient.uhid) && <div>{`UHID: `}{this.props.patient.uhid}</div>}

                                    <br />
                                    {"Contact Details: "}
                                    <div className={"patient-number"}>
                                        {updatedPatientPhoneNumber &&
                                            <div onClick={this.onMaskClick}>
                                                <MaskNumber phoneNumber={"Call Patient"} receiverPhoneNumber={updatedPatientPhoneNumber} shouldShowNumber meta={{ appointmentId: this.props.appointmentId }} />
                                            </div>
                                        }
                                        {!updatedPatientPhoneNumber &&
                                            <div onClick={this.onMaskClick}>
                                                <MaskNumber phoneNumber={"Call Patient"} userId={this.props.patient.curefitUserId} shouldShowNumber meta={{ appointmentId: this.props.appointmentId }} />
                                            </div>
                                        }
                                    </div>
                                    {!_.isEmpty(this.props.patient.emailId) && <div className={"patient-email"}>{this.props.patient.emailId}</div>}
                                    <br />

                                </div>
                                <div className="patient-linked-patients">
                                    <Popover
                                        style={{ zIndex: 9 }}
                                        onOuterAction={this.toggleRelatedPatientPopover}
                                        preferPlace="right" isOpen={isRelatedPopoverVisible}
                                        body={<RelatedPatientList onPatientClick={this.navigateToOtherPatientConsultationPage} />}
                                        target={<div>RELATED PATIENTS</div>}>
                                        <div onClick={this.toggleRelatedPatientPopover}>RELATED PATIENTS</div>
                                    </Popover>
                                </div>
                            </div>
                        </div>
                        <div className="patient-navs" onClick={this.handleUrlChange}>
                            <Nav className="nav navbar-nav" bsStyle="pills" stacked>
                                {
                                    _.map(routesList, function (patientNav, index) {
                                        if (patientNav.visibilityOn && appTenant !== patientNav.visibilityOn) return; //temp check for seperating features based on appTenant
                                        let currUrl = _myInstance.getPatientNav(patientNav.url);
                                        let isActive: boolean = location.toString().includes(currUrl);
                                        return (
                                            <LinkContainer to={currUrl} key={index}>
                                                <li role="presentation" className={isActive ? "active" : ""}>
                                                    <a title={patientNav.id} action="push" href={currUrl}>
                                                        <img className="unselected-img" src={ORION_IMG_URL + patientNav.id + ".png"} />
                                                        <img className="selected-img" src={ORION_IMG_URL + patientNav.id + "-red.png"} />
                                                        <span className="nav-label">{patientNav.label}</span>
                                                    </a>
                                                </li>
                                            </LinkContainer>

                                        )
                                    })
                                }
                            </Nav>
                        </div>
                    </div>
                }
                {isMobile &&
                    <div className="patient-left-nav-mobile">
                        <div className={"patient-number-mobile"}>
                            {updatedPatientPhoneNumber &&
                                <div onClick={this.onMaskClick}>
                                    <MaskNumber phoneNumber={"Call Patient"} receiverPhoneNumber={updatedPatientPhoneNumber} shouldShowNumber meta={{ appointmentId: this.props.appointmentId }} />
                                </div>
                            }
                            {!updatedPatientPhoneNumber &&
                                <div onClick={this.onMaskClick}>
                                    <MaskNumber phoneNumber={"Call Patient"} userId={this.props.patient.curefitUserId} shouldShowNumber meta={{ appointmentId: this.props.appointmentId }} />
                                </div>
                            }
                        </div>
                        {
                            _.map(RoutesConfig.PATIENT_NAVS, function (patientNav, index) {
                                if (patientNav.visibilityOn && appTenant !== patientNav.visibilityOn) return; //temp check for seperating features based on appTenant
                                let currUrl = _myInstance.getPatientNav(patientNav.url);
                                let isSelected: boolean = _myInstance.state.selectedUrl === currUrl;
                                return (
                                    <div className="tab-mobile" onClick={() => _myInstance.setState({ selectedUrl: currUrl })}>
                                        {!isSelected &&
                                            <LinkContainer to={currUrl} key={index}>
                                                <div>
                                                    {/*<img className="unselected-img" src={ORION_IMG_URL + patientNav.id + ".png"} />*/}
                                                    <span className="nav-label">{patientNav.label}</span>
                                                </div>
                                            </LinkContainer>
                                        }
                                        {isSelected &&
                                            <LinkContainer to={currUrl} key={index}>
                                                <div>
                                                    {/*<img className="selected-img" src={ORION_IMG_URL + patientNav.id + "-red.png"} />*/}
                                                    <span className="nav-label selected">{patientNav.label}</span>
                                                </div>
                                            </LinkContainer>
                                        }
                                    </div>

                                )
                            })
                        }
                    </div>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state: IAppState): LeftNavStateToProps => {
    return {
        updatedPatientPhoneNumber: state.overrides && state.overrides.patientPhoneNumber,
        doctorSubServices: _.get(state.doctorProfile, "resourceServiceMapping", null),
        appTenant: state.accountData.appTenant,
    }
}

export default connect<LeftNavStateToProps, void, LeftNavProps>(mapStateToProps, null)(PatientLeftNav);